export default "__VITE_ASSET__CO23eefI__"